import React, {PureComponent} from 'react';
import {connect} from 'react-redux';

import ArticlesList from '../../components/Blog/ArticlesList.jsx';

import ArticleCard from '../../components/Blog/ArticleCard/ArticleCard.jsx';
import DefaultLayout from '../Layout/DefaultLayout.jsx';
import Header from '../../components/Header/Header.jsx';
import Sidebar from './Sidebar.jsx';

import {loadArticles} from '../../components/Blog/actions.js';

const title = "Twineeds | Blog sur le Conseil Indépendant, le Recrutement & le Freelance";
const description = "Explorez nos articles sur le freelancing, le conseil indépendant et les évolutions du recrutement. Un blog dédié aux consultants experts et entreprises.";

class Blog extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      articles: []
    }
  }

  componentDidMount() {
    this.loadArticles();
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (prevProps?.match?.params?.slug !== this.props?.match?.params?.slug) {
      this.loadArticles();
    }
  }

  loadArticles = () => {
    this.setState({loading: true});
    this.props.loadArticles().then((articles) => {
      let filteredArticles = [];
      const requestSlug = this.props?.match?.params?.slug ?? null;

      if (requestSlug !== null) {
        if (this.props.route.name === 'blog-category') {
          filteredArticles = articles.filter(article => (article.category.slug === requestSlug));
        }
        if (this.props.route.name === 'blog-tag') {
          filteredArticles = articles.filter(article => {
            const tags = article.tags.map(tag => tag.slug);
            return tags.includes(requestSlug);
          });
        }
      } else {
        filteredArticles = articles;
      }
      this.setState({
        articles: filteredArticles,
        loading: false
      });
    });
  };

  render() {
    const headerBrief = <p>
      Retrouvez dans notre blog toutes les informations qui vous permettront de comprendre notre activité, notre marché,
      les conseils et démarches pour devenir travailleur autonome dans nos domaines d’activités. Nous vous expliquons
      tout en détail. Mais rappelez-vous, le plus simple est aussi de nous parler de votre projet ! Inscrivez-vous
      gratuitement en 2mn chrono et choisissez un créneau pour se rencontrer !
    </p>;

    return <DefaultLayout showSidebarMenu={false} helmet={{title, description}} className="blog">
      <Header brief={headerBrief} title="Le blog du consultant freelance"/>
      <section className="container d-flex flex-column flex-md-row my-md-5">
        <ArticlesList
          className="col-sm-9"
          articles={this.state.articles}
          card={ArticleCard}
          flex={false}
        />
        <Sidebar
          className="col-sm-3"
          articles={this.props.articles.slice(0, 5)}
        />
      </section>
    </DefaultLayout>;
  }
}

export default connect(
  state => ({
    articles: state.blog.articles,
  }),
  dispatch => ({
    loadArticles: () => dispatch(loadArticles()),
  })
)(Blog);